import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, withLatestFrom } from 'rxjs/operators';

import { addTuningControllers, initDeviceTuningControllers } from './tuning-controller.actions';
import { TuningController, tuningControllerId, tuningControllersMap } from './tuning-controller.model';
import { createTuningControllerByIdSelector } from './tuning-controller.selectors';

import { AppState } from './index';

@Injectable()
export class TuningControllerEffects {
  private actions$ = inject(Actions);
  private store$ = inject<Store<AppState>>(Store);

  addTuningControllersOnInitDeviceTuningControllers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(initDeviceTuningControllers), // TODO: Consider using the NgRx ROUTER_NAVIGATION action instead
      withLatestFrom(this.store$),
      map(([action, state]) => {
        const device = action.device;
        const tuningControllers: TuningController[] = [];

        tuningControllersMap.forEach((tuningController) => {
          const deviceTuningController = createTuningControllerByIdSelector(
            tuningControllerId(tuningController, device),
          ).projector(state.tuningControllers.entities);
          if (!deviceTuningController || !deviceTuningController.signalGeneratorType) {
            tuningControllers.push({
              ...tuningController,
              deviceSerialNumber: device.serialNumber,
              id: tuningControllerId(tuningController, device),
            } as TuningController);
          }
        });

        return addTuningControllers({ tuningControllers });
      }),
    ),
  );
}
